// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Users',
  subtitle: 'Manage system users',
  newUser: 'New User',
  editUser: 'Edit User',
  addUser: 'Add New User',
  userDetails: 'User Details',
  username: 'Username',
  fullName: 'Full Name',
  password: 'Password',
  newPassword: 'New Password',
  role: 'Role',
  roleAdmin: 'Administrator',
  roleManager: 'Manager',
  roleUser: 'User',
  lastLogin: 'Last Login',
  neverLoggedIn: 'Never logged in',
  searchPlaceholder: 'Search users...',
  noUsers: 'No users found yet',
  userCreated: 'User created successfully',
  userUpdated: 'User updated successfully',
  userDeleted: 'User deleted successfully',
  fetchError: 'Users could not be fetched',
  createError: 'User could not be created',
  updateError: 'User could not be updated',
  deleteError: 'User could not be deleted',
  confirmDelete: 'Are you sure you want to delete this user?'
};
